<template>
  <div>
    <div class="hidden-sm-and-down bg-nosotros-2" style="background-color: #ececee" data-aos="fade-right">
      <el-row :gutter="20"
        ><el-col :md="24"
          ><h2 class="title_desarrollo">{{ $t('cultura.titulo') }}</h2></el-col
        ></el-row
      >
      <el-row :gutter="20"
        ><el-col :md="24" style="margin-top: 0px; margin-bottom: 15px"><p class="msj_cultura" v-html="$t('cultura.mensaje')"></p></el-col
      ></el-row>

      <el-row :gutter="20" class="hidden-sm-and-down">
        <el-col>
          <img v-if="lenguaje == 'es'" width="100%" :src="require('@/assets/fotos/Nuestra Cultura.png')" alt="cambiar texto" />
          <img v-if="lenguaje == 'en'" width="100%" :src="require('@/assets/fotos/Our Culture.png')" alt="cambiar texto" />
        </el-col>
      </el-row>
    </div>
    <div class="hidden-md-and-up bg-nosotros-2" style="background-color: #ececee" data-aos="fade-right">
      <el-row
        ><el-col :md="24"
          ><h2 class="title_desarrollo">{{ $t('cultura.titulo') }}</h2></el-col
        ></el-row
      >
      <el-row
        ><el-col :md="24" style="margin-top: 0px; margin-bottom: 15px"><p style="margin-top:" class="msj_cultura" v-html="$t('cultura.mensaje')"></p></el-col
      ></el-row>

      <el-row class="hidden-sm-and-down">
        <el-col>
          <div class="valores-container"></div>
        </el-col>
      </el-row>
      <el-row class="hidden-md-and-up">
        <el-col>
          <img v-if="lenguaje === 'es'" width="100%" :src="require('@/assets/fotos/cultura_mobile.png')" alt="Nuestra Cultura" class="img_horizontal" />
          <img v-if="lenguaje === 'en'" width="100%" :src="require('@/assets/fotos/cultura_mobile_ingles.png')" alt="Our Culture" class="img_horizontal" />
        </el-col>
        <!-- <el-col>
          <p class="p-class">
            {{ $t('cultura.lista[0]') }}
          </p>
          <p class="p-class">
            {{ $t('cultura.lista[1]') }}
          </p>
          <p class="p-class">
            {{ $t('cultura.lista[2]') }}
          </p>
          <p class="p-class">
            {{ $t('cultura.lista[3]') }}
          </p>
          <p class="p-class">
            {{ $t('cultura.lista[4]') }}
          </p>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script>
// import accounting from 'accounting'
// import ICountUp from 'vue-countup-v2'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { EventBus } from '@/event-bus.js'

export default {
  // components: { ICountUp },

  data() {
    return { lenguaje: 'es' }
  },

  mounted() {
    this.lenguaje = this.$i18n.locale

    EventBus.$on('change-lenguaje', (lenguaje) => {
      this.lenguaje = lenguaje
    })
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })
  },
  beforeDestroy() {
    EventBus.$off('change-lenguaje', false)
  },
}
</script>
<style scoped>
.button-group >>> .el-button {
  margin: 5px;
  border-color: #ccc;
}

/* estilo cuando el botón está seleccionado */
.button-group >>> .active-button {
  color: #fff !important;
  background-color: #d35400 !important;
  border-color: #e9eef3 !important;
}
/* .button-left >>> .el-button:hover,
.button-left >>> .el-button:active {
  color: #fff !important;
  border-color: #e9eef3;
  background-color: #d35400;
} */
</style>
<style>
.p-class2 {
  font-size: 1em;
  line-height: 1.4;
  border-top: 3px solid;
  -o-border-image: linear-gradient(to right, #d35915 0%, #d35915 100%);
  border-image: linear-gradient(to right, #d35915 0%, #d35915 100%);
  border-image-slice: 1;
  border-width: 3px;
  margin: 0;
  padding: 30px;
  counter-increment: section;
  position: relative;
  /* color: #34435e; */
}
.p-class2:before {
  content: '+';
  position: absolute;
  border-radius: 50%;
  padding: 10px;
  height: 1.25em;
  width: 1.25em;
  background-color: #d35915;
  text-align: center;
  line-height: 1.25em;
  color: #ffffff;
  font-size: 1em;
}

.p-class2:nth-child(odd) {
  border-right: 3px solid;
  /* padding-left: 0; */
}
.p-class2:nth-child(odd):before {
  left: 100%;
  margin-left: -20px;
}

.p-class2:nth-child(even) {
  border-left: 3px solid;
  padding-right: 0;
}
.p-class2:nth-child(even):before {
  right: 100%;
  margin-right: -20px;
}

.p-class2:first-child {
  /* border-top: 0; */
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.p-class2:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: 3px solid;
}
.p-class {
  border-top: 2px dashed;
  border-color: #d35915 !important;
  margin: 0;
  padding: 30px;
}

.p-class:nth-child(even) {
  border-left: 2px dashed;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  margin-right: 30px;
  padding-right: 0;
}
.p-class:before {
  content: '+';
  position: absolute;
  border-radius: 50%;
  padding: 10px;
  height: 1.25em;
  width: 1.25em;
  background-color: #d35915;
  text-align: center;
  line-height: 1.25em;
  color: #ffffff;
  font-size: 1em;
}
.p-class:nth-child(odd) {
  border-right: 3px solid;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  margin-left: 30px;
  padding-left: 0;
}
.p-class:nth-child(odd):before {
  left: 100%;
  margin-left: -20px;
}

.p-class:nth-child(even) {
  border-left: 3px solid;
  padding-right: 0;
}
.p-class:nth-child(even):before {
  right: 100%;
  margin-right: -20px;
}
.p-class:first-child {
  border-top: 0;
  border-top-right-radius: 30px;
  /* border-top-left-radius: 30px; */
  border-top: 2px dashed;
}

.p-class:last-child {
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 2px;
  border-bottom: 2px dashed;
}
.flexing {
  display: flex;
  flex-direction: column;
  height: 50vh;
}
@media screen and (min-width: 1000px) {
  .flexing {
    flex-direction: row;
  }
}

.section {
  flex: 1;
  position: relative;
  transition: 0.5s ease;
}
.section--yellow {
  background-color: #d35915;
}
.section--white {
  background-color: #ffff;
}
.section--green {
  background-color: #03cea4;
}
.section:hover,
.section:active,
.section:focus {
  flex: 3;
}
.section:hover .title,
.section:active .title,
.section:focus .title {
  transform: translate(-50%, -50%) rotate(0);
}
@media screen and (min-width: 1000px) {
  .section:hover .title,
  .section:active .title,
  .section:focus .title {
    transform: translate(-50%, -50%) scale(1.25);
  }
}
.section .title {
  font-family: 'Fredoka One';
  font-size: 5rem;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.5s ease;
}
@media screen and (min-width: 1000px) {
  .section .title {
    transform: translate(-50%, -50%) rotate(90deg);
  }
}

.msj_cultura {
  font-family: 'roboto-regular';
  margin-top: 0px;
}
.card-css {
  border-radius: 4px;
  border: 1px solid #d35400 !important;
  background-color: transparent !important;
}
.valores-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid #d35400;
  border-radius: 0 0 8px 8px;
  background-color: transparent;
  padding: 30px 20px 20px;
  position: relative;
  overflow: visible;
  border-bottom-left-radius: 60px;
}

.valor {
  width: 100%;
  position: relative;
  text-align: justify;
  color: #d35400;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  line-height: 1.5;
}

/* .valor  */
.icono_extra {
  position: relative;
  /* top: -50px; */
  /* left: 50%; */
  /* transform: translateX(-300%); */
  width: 40px;
  height: 40px;
  /* background-color: #d35400; */
  color: #fff;
  font-weight: 500;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 30px; */
}
.icono_extra-orange {
  position: relative;
  /* top: -50px; */
  /* left: 50%; */
  /* transform: translateX(-300%); */
  width: 40px;
  height: 40px;
  /* background-color: #d35400; */
  color: #d35400;
  font-weight: 500;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 30px; */
}
.text-cuadros-plus {
  font-family: 'roboto-regular';
  /* font-size: 0.8rem; */
  text-align: start;
  padding-left: 10%;
}

.title_desarrollo {
  color: #d35400;
  font-family: 'roboto-cursiva-black';
  /* margin-bottom: 2.5%; */
}

@media (min-width: 2561px) {
  .title_desarrollo {
    font-size: 62px;
  }
  .text-cuadros-plus {
    font-size: 20px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .title_desarrollo {
    font-size: 62px;
  }
  .text-cuadros-plus {
    font-size: 19px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -50px;
    left: 80%;
    transform: translateX(-550%);
    width: 40px;
    height: 40px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .title_desarrollo {
    font-size: 56px;
  }
  .text-cuadros-plus {
    font-size: 17px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -50px;
    left: 85%;
    transform: translateX(-550%);
    width: 40px;
    height: 40px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .title_desarrollo {
    font-size: 50px;
  }
  .text-cuadros-plus {
    font-size: 16px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -45px;
    left: 83%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .title_desarrollo {
    font-size: 40px;
  }
  .text-cuadros-plus {
    font-size: 16px;
  }
  .valor {
    width: 90% !important;
  }
  .valor .icono_extra {
    position: absolute;
    top: -45px;
    left: 110%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  .img_horizontal {
    width: 70% !important;
  }
}
@media (orientation: landscape) and (max-height: 667px) {
  .img_horizontal {
    width: 60% !important;
  }
}
/* @media screen and (min-width: 599px) and (max-width: 767px) {
  .title_desarrollo {
    font-size: 31px;
  }
  .text-cuadros-plus {
    font-size: 16px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 43%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
@media screen and (min-width: 480px) and (max-width: 598px) {
  .title_desarrollo {
    font-size: 31px;
  }
  .text-cuadros-plus {
    font-size: 16px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 43%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
@media screen and (min-width: 376px) and (max-width: 480px) {
  .title_desarrollo {
    font-size: 25px;
  }
  .text-cuadros-plus {
    font-size: 17px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 43%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
} */
@media screen and (min-width: 375px) and (max-width: 767px) {
  .img_horizontal {
    width: 90% !important;
  }
  .title_desarrollo {
    font-size: 28px;
    margin-bottom: 8%;
    line-height: 1;

    /* margin: 5% 0px 10% 0px; */
  }
  .text-cuadros-plus {
    font-size: 16px;
    padding-left: 5%;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 48%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
@media (max-width: 375px) {
  .title_desarrollo {
    font-size: 35px;
    line-height: 1;
    margin-bottom: 8%;

    /* margin: 5% 0px 10% 0px; */
  }
  .text-cuadros-plus {
    font-size: 16px;
    padding-left: 5%;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 52%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
/* @media (max-width: 375px) {
  .title_desarrollo {
    font-size: 25px;
  }
  .text-cuadros-plus {
    font-size: 18px;
  }
  .valor .icono_extra {
    position: absolute;
    top: -15px;
    left: 43%;
    transform: translateX(-550%);
    width: 30px;
    height: 30px;
    background-color: #d35400;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
} */
</style>
